import {
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from '@material-ui/core';

export const renderCheckbox = (name: any, value: any, setValue: any) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          style={{ padding: 7 }}
          checked={value}
          onChange={() => {
            setValue(name);
          }}
          color="primary"
        />
      }
      label={
        <Typography
          style={{
            fontWeight: 'bold',
            minWidth: 100,
          }}
          color="primary"
        >
          {name}
        </Typography>
      }
      style={{ fontSize: 14 }}
    />
  );
};

const TemplateOptions = ({ temp, setTemp }) => {
  if (!temp) return <div></div>;
  const {
    options,
    taskoptions,
    resorseoptions,
    employeeoptions,
    departmentoptions,
    customeroptions,
    supplieroptions,
    frontpageoptions,
    uploadoptions,
  } = temp;
  const setOption = (name: any) => {
    const newtemp = {
      ...temp,
      options: { ...temp.options, [name]: !options[name] },
    };
    setTemp(newtemp);
  };
  const setContractoptions = (name: any) => {
    const newtemp = {
      ...temp,
      taskoptions: { ...temp.taskoptions, [name]: !taskoptions[name] },
    };
    setTemp(newtemp);
  };
  const setResourseoptions = (name: any) => {
    const newtemp = {
      ...temp,
      resorseoptions: { ...temp.resorseoptions, [name]: !resorseoptions[name] },
    };
    setTemp(newtemp);
  };
  const setEmployeeoptions = (name: any) => {
    const newtemp = {
      ...temp,
      employeeoptions: {
        ...temp.employeeoptions,
        [name]: !employeeoptions[name],
      },
    };
    setTemp(newtemp);
  };
  const setDepartmentoptions = (name: any) => {
    const newtemp = {
      ...temp,
      departmentoptions: {
        ...temp.departmentoptions,
        [name]: !departmentoptions[name],
      },
    };
    setTemp(newtemp);
  };
  const setCustomeroptions = (name: any) => {
    const newtemp = {
      ...temp,
      customeroptions: {
        ...temp.customeroptions,
        [name]: !customeroptions[name],
      },
    };
    setTemp(newtemp);
  };
  const setSupplieroptions = (name: any) => {
    const newtemp = {
      ...temp,
      supplieroptions: {
        ...temp.supplieroptions,
        [name]: !supplieroptions[name],
      },
    };
    setTemp(newtemp);
  };
  const setFrontpageoptions = (name: any) => {
    const newtemp = {
      ...temp,
      frontpageoptions: {
        ...temp.frontpageoptions,
        [name]: !frontpageoptions[name],
      },
    };
    setTemp(newtemp);
  };
  const setUploadoptions = (name: any) => {
    const newtemp = {
      ...temp,
      uploadoptions: {
        ...temp.uploadoptions,
        [name]: !uploadoptions[name],
      },
    };
    setTemp(newtemp);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Main Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('customer', options.customer, setOption)}
        {renderCheckbox('supplier', options.supplier, setOption)}
        {renderCheckbox('contract', options.contract, setOption)}
        {renderCheckbox('resourse', options.resourse, setOption)}
        {renderCheckbox('department', options.department, setOption)}
        {renderCheckbox('employee', options.employee, setOption)}
        {renderCheckbox('dochirtory', options.dochirtory, setOption)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('nameonelang', options.nameonelang, setOption)}
        {renderCheckbox('pos', options.pos, setOption)}
        {renderCheckbox('sms', options.sms, setOption)}
        {renderCheckbox('notification', options.notification, setOption)}
        {renderCheckbox(
          'emailnotification',
          options.emailnotification,
          setOption
        )}
        {renderCheckbox('approval', options.approval, setOption)}
        {renderCheckbox('credit', options.credit, setOption)}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Front Page</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('daysep', frontpageoptions.daysep, setFrontpageoptions)}
        {renderCheckbox(
          'monthsep',
          frontpageoptions.monthsep,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'yearsep',
          frontpageoptions.yearsep,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'raseeds',
          frontpageoptions.raseeds,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'cashflow',
          frontpageoptions.cashflow,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'contract',
          frontpageoptions.contract,
          setFrontpageoptions
        )}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox(
          'resourse',
          frontpageoptions.resourse,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'department',
          frontpageoptions.department,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'employee',
          frontpageoptions.employee,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'docsqty',
          frontpageoptions.docsqty,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'docslist',
          frontpageoptions.docslist,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'customerbalance',
          frontpageoptions.customerbalance,
          setFrontpageoptions
        )}
        {renderCheckbox(
          'supplierbalance',
          frontpageoptions.supplierbalance,
          setFrontpageoptions
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Upload</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('customer', uploadoptions.customer, setUploadoptions)}
        {renderCheckbox('supplier', uploadoptions.supplier, setUploadoptions)}
        {renderCheckbox('contract', uploadoptions.contract, setUploadoptions)}
        {renderCheckbox('resourse', uploadoptions.resourse, setUploadoptions)}
        {renderCheckbox(
          'department',
          uploadoptions.department,
          setUploadoptions
        )}
        {renderCheckbox('employee', uploadoptions.employee, setUploadoptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('time', uploadoptions.time, setUploadoptions)}
        {renderCheckbox('amount', uploadoptions.amount, setUploadoptions)}
        {renderCheckbox('account', uploadoptions.account, setUploadoptions)}
        {renderCheckbox('doctype', uploadoptions.doctype, setUploadoptions)}
        {renderCheckbox('desc', uploadoptions.desc, setUploadoptions)}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Contract Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('customer', taskoptions.customer, setContractoptions)}
        {renderCheckbox(
          'customerrequire',
          taskoptions.customerrequire,
          setContractoptions
        )}
        {renderCheckbox('employee', taskoptions.employee, setContractoptions)}
        {renderCheckbox(
          'employeerequire',
          taskoptions.employeerequire,
          setContractoptions
        )}
        {renderCheckbox(
          'department',
          taskoptions.department,
          setContractoptions
        )}
        {renderCheckbox('resourse', taskoptions.resourse, setContractoptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox(
          'resourserequire',
          taskoptions.resourserequire,
          setContractoptions
        )}
        {renderCheckbox('desc', taskoptions.desc, setContractoptions)}
        {renderCheckbox('printdate', taskoptions.printdate, setContractoptions)}
        {renderCheckbox('address', taskoptions.address, setContractoptions)}
        {renderCheckbox('deposit', taskoptions.deposit, setContractoptions)}
        {renderCheckbox('photos', taskoptions.photos, setContractoptions)}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Resourse Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('workId', resorseoptions.workId, setResourseoptions)}
        {renderCheckbox('city', resorseoptions.city, setResourseoptions)}
        {renderCheckbox('address', resorseoptions.address, setResourseoptions)}
        {renderCheckbox('color', resorseoptions.color, setResourseoptions)}
        {renderCheckbox('status', resorseoptions.status, setResourseoptions)}
        {renderCheckbox('brand', resorseoptions.brand, setResourseoptions)}
        {renderCheckbox('model', resorseoptions.model, setResourseoptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('cost', resorseoptions.cost, setResourseoptions)}
        {renderCheckbox('purtime', resorseoptions.purtime, setResourseoptions)}
        {renderCheckbox(
          'insurance',
          resorseoptions.insurance,
          setResourseoptions
        )}
        {renderCheckbox('photos', resorseoptions.photos, setResourseoptions)}
        {renderCheckbox(
          'location',
          resorseoptions.location,
          setResourseoptions
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Employee Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('target', employeeoptions.target, setEmployeeoptions)}
        {renderCheckbox('workId', employeeoptions.workId, setEmployeeoptions)}
        {renderCheckbox('telHome', employeeoptions.telHome, setEmployeeoptions)}
        {renderCheckbox(
          'national',
          employeeoptions.national,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'nationalNo',
          employeeoptions.nationalNo,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'nationalDate',
          employeeoptions.nationalDate,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'licenseNo',
          employeeoptions.licenseNo,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'licenseDate',
          employeeoptions.licenseDate,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'startWorkDate',
          employeeoptions.startWorkDate,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'basicSalary',
          employeeoptions.basicSalary,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'extraSalary',
          employeeoptions.extraSalary,
          setEmployeeoptions
        )}
        {renderCheckbox('daysoff', employeeoptions.daysoff, setEmployeeoptions)}
        {renderCheckbox(
          'speciality',
          employeeoptions.speciality,
          setEmployeeoptions
        )}
        {renderCheckbox('color', employeeoptions.color, setEmployeeoptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('tel', employeeoptions.tel, setEmployeeoptions)}
        {renderCheckbox('fax', employeeoptions.fax, setEmployeeoptions)}
        {renderCheckbox('mobile', employeeoptions.mobile, setEmployeeoptions)}
        {renderCheckbox('email', employeeoptions.email, setEmployeeoptions)}
        {renderCheckbox('city', employeeoptions.city, setEmployeeoptions)}
        {renderCheckbox('address', employeeoptions.address, setEmployeeoptions)}
        {renderCheckbox('pId', employeeoptions.pId, setEmployeeoptions)}
        {renderCheckbox('pIdDate', employeeoptions.pIdDate, setEmployeeoptions)}
        {renderCheckbox('photos', employeeoptions.photos, setEmployeeoptions)}
        {renderCheckbox(
          'location',
          employeeoptions.location,
          setEmployeeoptions
        )}
        {renderCheckbox(
          'department',
          employeeoptions.department,
          setEmployeeoptions
        )}
        {renderCheckbox('info', employeeoptions.info, setEmployeeoptions)}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Department Options</Typography>
      </Grid>
      <Grid item xs={12}>
        {renderCheckbox('color', departmentoptions.color, setDepartmentoptions)}
        {renderCheckbox('desc', departmentoptions.desc, setDepartmentoptions)}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Customer Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('tel', customeroptions.tel, setCustomeroptions)}
        {renderCheckbox('fax', customeroptions.fax, setCustomeroptions)}
        {renderCheckbox('mobile', customeroptions.mobile, setCustomeroptions)}
        {renderCheckbox('email', customeroptions.email, setCustomeroptions)}
        {renderCheckbox('city', customeroptions.city, setCustomeroptions)}
        {renderCheckbox('address', customeroptions.address, setCustomeroptions)}
        {renderCheckbox('balance', customeroptions.balance, setCustomeroptions)}
        {renderCheckbox('area', customeroptions.area, setCustomeroptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox(
          'national',
          customeroptions.national,
          setCustomeroptions
        )}
        {renderCheckbox(
          'nationalNo',
          customeroptions.nationalNo,
          setCustomeroptions
        )}
        {renderCheckbox(
          'nationalDate',
          customeroptions.nationalDate,
          setCustomeroptions
        )}
        {renderCheckbox(
          'location',
          customeroptions.location,
          setCustomeroptions
        )}
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">Supplier Options</Typography>
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('tel', supplieroptions.tel, setSupplieroptions)}
        {renderCheckbox('fax', supplieroptions.fax, setSupplieroptions)}
        {renderCheckbox('mobile', supplieroptions.mobile, setSupplieroptions)}
        {renderCheckbox('email', supplieroptions.email, setSupplieroptions)}
      </Grid>
      <Grid item xs={6}>
        {renderCheckbox('city', supplieroptions.city, setSupplieroptions)}
        {renderCheckbox('address', supplieroptions.address, setSupplieroptions)}
        {renderCheckbox('balance', supplieroptions.balance, setSupplieroptions)}
      </Grid>
    </Grid>
  );
};

export default TemplateOptions;
